import React from 'react'

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import {Header} from './Components/Header'
import Slider from './Components/Slider';
import Form from './Components/Form';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import Footer from './Components/Footer';
import Layout from './Components/Layout';
import ModularKitchen from './pages/Design Gallery/ModularKitchen';
import Wardrobe from './pages/Design Gallery/Wardrobe';
import Bedroom from './pages/Design Gallery/Bedroom';
import LivingRoom from './pages/Design Gallery/LivingRoom';
import ContactUs from './pages/More/ContactUs';
import SpaceSaving from './pages/Design Gallery/SpaceSaving';
import DiningRoom from './pages/Design Gallery/DiningRoom';
import Guide from  './pages/Guides/Guide';
import Modular from './pages/Guides/Modular';
import BedroomGuide from './pages/Guides/BedroomGuide';
import LivingroomGuide from './pages/Guides/LivingroomGuide';
import HomeOffice from './pages/Design Gallery/HomeOffice';
import PrivacyPolicy from './pages/FooterTermAndPrivacy/PrivacyPolicy';
import TermsAndConditions from './pages/FooterTermAndPrivacy/TermsAndConditions';
import ScrollTop from './pages/Guides/ScrollTop';
import KidsBedroom from './pages/Design Gallery/KidsBedroom';
import Bathroom from './pages/Design Gallery/Bathroom';
import Faqs from './pages/More/Faqs';


const App = () => {
  
  return (
    <div>
        {/* <Header/> */}
        <ScrollTop/>

        <Routes>
          <Route path="/" element={<Layout><Home/></Layout>}/>
          <Route path="/form" element={<Form/>}/>
          <Route path='/modularkitchen' element={<Layout><ModularKitchen/></Layout>}/>
          <Route path='/wardrobe' element={<Layout><Wardrobe/></Layout>}/>
          <Route path='/bedroom' element={<Layout><Bedroom/></Layout>}/>
          <Route path='/livingroom' element={<Layout><LivingRoom/></Layout>}/>
          <Route path='/spacesavingdesigns' element={<Layout><SpaceSaving/></Layout>}/>
          <Route path='/dinningroom' element={<Layout><DiningRoom/></Layout>}/>
          <Route path='/homeoffice' element={<Layout><HomeOffice/></Layout>}/>
          <Route path='/kids' element={<Layout><KidsBedroom/></Layout>}/>
          <Route path='/bathroom' element={<Layout><Bathroom/></Layout>}/>

          <Route path='/contactus' element={<Layout><ContactUs/></Layout>}/>
          <Route path ='/faqsmore' element={<Layout><Faqs></Faqs></Layout>}/>
          <Route path='/guide' element={<Layout><Guide/></Layout>}>
              <Route path='modular' element={<Modular/>}/>
              <Route path='bedroomguide' element={<BedroomGuide/>}/>
              <Route path='livingroomguide' element={<LivingroomGuide/>}/>

          </Route>
          <Route path='/privacypolicy' element={<Layout><PrivacyPolicy/></Layout>}/>
          <Route path='/termsandconditions' element={<Layout><TermsAndConditions/></Layout>}/>
          

          
          
         
        </Routes>
        {/* <Footer/> */}
    </div>
  )
}

export default App